// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   Login Page
   ═══════════════════════════════════════════════════════════ */

.login-page {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
}

.login-container {
  position: relative;
  width: 100%;
  max-width: 440px;
}

/* ── Decorative glows ─────────────────────────── */

.login-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  pointer-events: none;
  z-index: -1;
}

.login-glow--top {
  width: 300px;
  height: 300px;
  background: rgba(16, 185, 129, 0.12);
  top: -80px;
  left: -60px;
  animation: pulse-glow 6s ease-in-out infinite;
}

.login-glow--bottom {
  width: 250px;
  height: 250px;
  background: rgba(139, 92, 246, 0.1);
  bottom: -60px;
  right: -50px;
  animation: pulse-glow 6s ease-in-out infinite 3s;
}

@keyframes pulse-glow {
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

/* ── Card ─────────────────────────────────────── */

.login-card {
  padding: 48px 40px;
  text-align: center;
  animation: card-enter 0.6s ease-out;
}

@keyframes card-enter {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ── Header ───────────────────────────────────── */

.login-header {
  margin-bottom: 32px;
}

.login-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 28px;
}

.login-logo__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  background: linear-gradient(135deg, var(--accent-emerald) 0%, var(--accent-purple) 100%);
  color: white;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
}

.login-logo__text {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.login-title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-bottom: 8px;
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--text-secondary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-subtitle {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.5;
}

/* ── Error ────────────────────────────────────── */

.login-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  border-radius: var(--radius-sm);
  background: rgba(244, 63, 94, 0.1);
  border: 1px solid rgba(244, 63, 94, 0.2);
  color: var(--accent-rose);
  font-size: 13px;
  text-align: left;
}

/* ── Button ───────────────────────────────────── */

.login-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--bg-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--bg-glass-hover);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.login-btn:hover:not(:disabled)::before {
  opacity: 1;
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-btn__ms-icon {
  flex-shrink: 0;
}

.login-btn__spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-subtle);
  border-top-color: var(--accent-emerald);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Footer ───────────────────────────────────── */

.login-footer {
  margin-top: 28px;
}

.login-footer__text {
  color: var(--text-muted);
  font-size: 12px;
}

.login-footer__dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
}

.login-footer__dots span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--text-muted);
  opacity: 0.5;
}

/* ── Responsive ───────────────────────────────── */

@media (max-width: 480px) {
  .login-card {
    padding: 36px 24px;
  }

  .login-title {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA,oDAAoD;;AAEpD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oDAAoD;;AAEpD;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,wFAAwF;EACxF,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,uFAAuF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,uCAAuC;EACvC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oDAAoD;;AAEpD;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA,oDAAoD;;AAEpD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   Login Page\n   ═══════════════════════════════════════════════════════════ */\n\n.login-page {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 24px;\n}\n\n.login-container {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n}\n\n/* ── Decorative glows ─────────────────────────── */\n\n.login-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(100px);\n  pointer-events: none;\n  z-index: -1;\n}\n\n.login-glow--top {\n  width: 300px;\n  height: 300px;\n  background: rgba(16, 185, 129, 0.12);\n  top: -80px;\n  left: -60px;\n  animation: pulse-glow 6s ease-in-out infinite;\n}\n\n.login-glow--bottom {\n  width: 250px;\n  height: 250px;\n  background: rgba(139, 92, 246, 0.1);\n  bottom: -60px;\n  right: -50px;\n  animation: pulse-glow 6s ease-in-out infinite 3s;\n}\n\n@keyframes pulse-glow {\n  0%, 100% { opacity: 0.6; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.1); }\n}\n\n/* ── Card ─────────────────────────────────────── */\n\n.login-card {\n  padding: 48px 40px;\n  text-align: center;\n  animation: card-enter 0.6s ease-out;\n}\n\n@keyframes card-enter {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ── Header ───────────────────────────────────── */\n\n.login-header {\n  margin-bottom: 32px;\n}\n\n.login-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 28px;\n}\n\n.login-logo__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md);\n  background: linear-gradient(135deg, var(--accent-emerald) 0%, var(--accent-purple) 100%);\n  color: white;\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);\n}\n\n.login-logo__text {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.02em;\n}\n\n.login-title {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  margin-bottom: 8px;\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--text-secondary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.login-subtitle {\n  color: var(--text-secondary);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n/* ── Error ────────────────────────────────────── */\n\n.login-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  border-radius: var(--radius-sm);\n  background: rgba(244, 63, 94, 0.1);\n  border: 1px solid rgba(244, 63, 94, 0.2);\n  color: var(--accent-rose);\n  font-size: 13px;\n  text-align: left;\n}\n\n/* ── Button ───────────────────────────────────── */\n\n.login-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 14px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: var(--bg-glass-hover);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.login-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.login-btn:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.login-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login-btn__ms-icon {\n  flex-shrink: 0;\n}\n\n.login-btn__spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-subtle);\n  border-top-color: var(--accent-emerald);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Footer ───────────────────────────────────── */\n\n.login-footer {\n  margin-top: 28px;\n}\n\n.login-footer__text {\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.login-footer__dots {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 16px;\n}\n\n.login-footer__dots span {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--text-muted);\n  opacity: 0.5;\n}\n\n/* ── Responsive ───────────────────────────────── */\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 36px 24px;\n  }\n\n  .login-title {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
